export default function CustomButton({
  label,
  buttonClass = "bg-custom-gradient flex gap-2.5 items-center p-4 rounded-md transition-all duration-300 ease-in-out hover:brightness-110 hover:shadow-lg",
  labelClass = "text-sm font-medium whitespace-nowrap",
  rightIcon,
  leftIcon,
  rightIconClass,
  onClick,
  type = "button",
  disabled,
  width,
  buttonStyle
}) {
  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      className={` ${buttonClass} ${width} ${
        disabled ? "opacity-50 cursor-not-allowed" : ""
      }`}
      style={buttonStyle}
    >
      {leftIcon && leftIcon}
      <span className={labelClass}>{label}</span>
      {rightIcon && (
        <img src={rightIcon} alt="Icon" className={`${rightIconClass}`} />
      )}
    </button>
  );
}
